export const EXCLUDED_ROUTES = [
  '/',
  '/login',
  '/no-auth',
  '/cookie-settings',
  '/terms-of-use',
  '/privacy-notice',
  '/cookie-policies',
  '/error',
  '/client-management',
  '/user-management',
  '/escalations',
  '/help',
  '/project-management',
  '/project-management/project-details',
];
